import { GridColDef } from "@mui/x-data-grid";

import DataGridTextHeader from "../../molecules/DataGridTextHeader";

export const customerInfoColumns: GridColDef[] = [
  {
    field: "omneId",
    headerName: "Omne ID",
    width: 350,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "omneName",
    headerName: "Omne Name",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "signupCountry",
    headerName: "Signup Country",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "accountCreationDate",
    headerName: "Create Date",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "email",
    headerName: "Email",
    width: 250,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "dob",
    headerName: "DOB",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "gender",
    headerName: "Gender",
    width: 120,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "referralCode",
    headerName: "Referral Code",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "insuranceLinkedDate",
    headerName: "Insurance Linked Date",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "campaignCode",
    headerName: "Campaign Code",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "accountStatus",
    headerName: "Account Status",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "updatedDateTime",
    headerName: "Updated Date Time",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "lastActiveDateTime",
    headerName: "Last Active Date Time",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "deviceMakeAndModel",
    headerName: "Device Make And Model",
    width: 130,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "totalEarned",
    headerName: "Total Earned",
    width: 130,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "totalBurned",
    headerName: "Total Burned",
    width: 130,
    sortable: false,
    disableColumnMenu: true,
  },
];
